import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import {
	ARMainLocale,
	AR_Dashboard,
	AR_Dropdowns,
	AR_EduactionalInfo,
	AR_FAQs,
	AR_Inputs,
	AR_LandingPage,
	AR_Layouts,
	AR_Login,
	AR_Search,
	AR_Instructor,
	AR_Webinar,
	AR_PaymentFees,
	AR_Generic,
	AR_Signup,
	AR_Classroom,
	AR_Wallet,
	AR_CourseOverview,
	AR_Payment,
	AR_Test,
	AR_Note,
	AR_ClassroomsOverview,
	AR_ActivityHub,
	AR_StandaloneCourse,
	AR_Bundle,
	AR_StaticPages,
	AR_ClassroomTests,
	AR_About,
	AR_StudentDashboard,
	AR_Settings,
	AR_Assignment,
} from './ar'
import {
	ENMainLocale,
	EN_Dashboard,
	EN_Dropdowns,
	EN_EduactionalInfo,
	EN_FAQs,
	EN_Inputs,
	EN_LandingPage,
	EN_Layouts,
	EN_Login,
	EN_Search,
	EN_Instructor,
	EN_webinar,
	EN_PaymentFees,
	EN_Generic,
	EN_Signup,
	EN_Classroom,
	EN_Wallet,
	EN_CourseOverview,
	EN_Payment,
	EN_Test,
	EN_Note,
	EN_ClassroomsOverview,
	EN_ActivityHub,
	EN_StandaloneCourse,
	EN_Bundle,
	EN_StaticPages,
	EN_ClassroomTests,
	EN_About,
	EN_StudentDashboard,
	EN_Settings,
	EN_Assignment,
} from './en'
import LanguageDetector from 'i18next-browser-languagedetector'
import moment from 'moment'
import 'moment/locale/ar'
import 'moment/locale/en-gb'

// Numeral policy: the Arabic surface keeps Arabic month/day names and م/ص
// markers but Western (Latin) digits — the Egyptian convention. Without this,
// moment's ar locale postformats every digit to Arabic-Indic (٢٦/٠٦/٢٠٢٦).
moment.updateLocale('ar', {
	preparse: (s: string) => s,
	postformat: (s: string) => s,
})
const resources = {
	en: {
		translation: ENMainLocale,
		educational_info: EN_EduactionalInfo,
		landingPage: EN_LandingPage,
		layouts: EN_Layouts,
		login: EN_Login,
		inputs: EN_Inputs,
		dashboard: EN_Dashboard,
		dropdowns: EN_Dropdowns,
		FAQs: EN_FAQs,
		search: EN_Search,
		instructor: EN_Instructor,
		webinar: EN_webinar,
		fees: EN_PaymentFees,
		signup: EN_Signup,
		generic: EN_Generic,
		classroom: EN_Classroom,
		wallet: EN_Wallet,
		course: EN_CourseOverview,
		payment: EN_Payment,
		test: EN_Test,
		note: EN_Note,
		classroomsOverview: EN_ClassroomsOverview,
		activity_hub: EN_ActivityHub,
		standalone_course: EN_StandaloneCourse,
		bundle: EN_Bundle,
		static_pages: EN_StaticPages,
		classroomTests: EN_ClassroomTests,
		about: EN_About,
		studentDashboard: EN_StudentDashboard,
		settings: EN_Settings,
		assignment: EN_Assignment,
	},
	ar: {
		translation: ARMainLocale,
		educational_info: AR_EduactionalInfo,
		landingPage: AR_LandingPage,
		layouts: AR_Layouts,
		login: AR_Login,
		inputs: AR_Inputs,
		dashboard: AR_Dashboard,
		dropdowns: AR_Dropdowns,
		FAQs: AR_FAQs,
		search: AR_Search,
		instructor: AR_Instructor,
		webinar: AR_Webinar,
		fees: AR_PaymentFees,
		signup: AR_Signup,
		generic: AR_Generic,
		classroom: AR_Classroom,
		wallet: AR_Wallet,
		course: AR_CourseOverview,
		payment: AR_Payment,
		test: AR_Test,
		note: AR_Note,
		classroomsOverview: AR_ClassroomsOverview,
		activity_hub: AR_ActivityHub,
		standalone_course: AR_StandaloneCourse,
		bundle: AR_Bundle,
		static_pages: AR_StaticPages,
		classroomTests: AR_ClassroomTests,
		about: AR_About,
		studentDashboard: AR_StudentDashboard,
		settings: AR_Settings,
		assignment: AR_Assignment,
	},
}

i18n.on('languageChanged', lng => {
	localStorage.setItem('lang', lng)
	// Match any Arabic variant ('ar', 'ar-EG', …) like the 'initialized' handler
	// below — a strict 'ar-EG' check leaves the page LTR for e.g. ?lng=ar.
	if ((lng || '').toLowerCase().startsWith('ar')) {
		document.body.dir = 'rtl'
		document.documentElement.lang = 'ar-EG'
		moment.locale('ar')
		document.dir = 'rtl'
	} else {
		document.documentElement.lang = 'en-GB'
		moment.locale('en')
		document.body.dir = ''
		document.dir = ''
	}
})
i18n.on('initialized', function () {
	// Apply direction/locale from the language i18next actually resolved (for a
	// guest with no saved choice that's the Arabic fallback) — not from
	// localStorage, otherwise the Arabic default would render left-to-right.
	const isArabic = (i18n.language || '').toLowerCase().startsWith('ar')
	moment.locale(isArabic ? 'ar' : 'en')
	document.documentElement.lang = isArabic ? 'ar-EG' : 'en-GB'
	document.body.dir = isArabic ? 'rtl' : ''
	document.dir = isArabic ? 'rtl' : ''
})
i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		detection: {
			// No `navigator`/`htmlTag`: guests default to Arabic (fallbackLng)
			// regardless of browser language; a saved choice still wins.
			order: ['querystring', 'localStorage', 'cookie'],
			lookupQuerystring: 'lng',
			lookupLocalStorage: 'lang',
			caches: ['localStorage'],
		},
		resources: resources,
		fallbackLng: 'ar-EG',
		interpolation: {
			escapeValue: true,
		},
		editor: {
			autoOpen: true,
			enabled: true,
			mode: 'iframe',
		},
		react: {
			bindI18n: 'loaded languageChanged',
			bindI18nStore: 'added',
			useSuspense: true,
		},
	})

export default i18n
